import React, { useEffect, useRef, useState } from "react";
import { Wrapper, ContentTypeRender } from "nystem-components";

const BootstrapCssClassByVal = ({ model, path, value, view }) => {
  const { condition, item, className, pointerClassName } = model;
  const ref = useRef();
  const [pointerOver, setPointerOver] = useState(false);

  useEffect(() => {
    if (!pointerClassName) return;
    const onWindowLeave = (event) => {
      if (event.relatedTarget !== null) return;
      setPointerOver(false);
    };
    const onBlur = () => setPointerOver(false);
    const onPlayerPointer = ({ pointerOver, clientX, clientY }) => {
      const bounds = ref.current?.getBoundingClientRect();
      setPointerOver(
        Boolean(
          pointerOver &&
          bounds &&
          clientX >= bounds.left &&
          clientX < bounds.right &&
          clientY >= bounds.top &&
          clientY < bounds.bottom,
        ),
      );
    };
    const onPointerMove = ({ clientX, clientY }) => onPlayerPointer({ pointerOver: true, clientX, clientY });
    view.on("playerPointer", onPlayerPointer);
    document.addEventListener("pointermove", onPointerMove);
    document.addEventListener("pointerout", onWindowLeave);
    document.addEventListener("mouseleave", onWindowLeave);
    window.addEventListener("blur", onBlur);
    return () => {
      view.off("playerPointer", onPlayerPointer);
      document.removeEventListener("pointermove", onPointerMove);
      document.removeEventListener("pointerout", onWindowLeave);
      document.removeEventListener("mouseleave", onWindowLeave);
      window.removeEventListener("blur", onBlur);
    };
  }, [view, pointerClassName]);

  const getClass = (value) => {
    const addClass = [];
    // 0-field, 1-vlaue, 2-cssClass
    for (let i = 0; condition && i < condition.length; i++)
      if (value[condition[i][0]] === condition[i][1]) addClass.push(condition[i][2]);
    return ` ${addClass.join(" ")}`;
  };

  const addClass = getClass(value);

  return (
    <Wrapper
      ref={ref}
      className={[...className, addClass, pointerOver && pointerClassName]}
      onPointerEnter={pointerClassName ? () => setPointerOver(true) : undefined}
      onPointerLeave={pointerClassName ? () => setPointerOver(false) : undefined}
    >
      <ContentTypeRender path={path} items={item} />
    </Wrapper>
  );
};

export default BootstrapCssClassByVal;
